import { BootResponse } from '../constants/apiResponses.types';
import { decodeAndSanitizeBase64Html, sanitizeRichText } from './sanitizeHtml';
import { getStoreSettings } from './storeSettings';

export interface MaintenanceModeState {
  isActive: boolean;
  sanitizedHtml: string;
  fontColor?: string;
  fontFamily?: string;
  logo?: string;
  backgroundImageMobile?: string;
  backgroundImageDesktop?: string;
}

const isBase64 = (str: string): boolean => {
  if (!str || str.length < 4) return false;
  return /^[A-Za-z0-9+/\n\r]+=*$/.test(str.trim());
};

export const resolveMaintenanceModeEnabled = (
  publisherMetaData?: BootResponse | null
): boolean => {
  return Boolean(
    publisherMetaData?.storeTheme?.storeSettings?.isMaintenanceModeEnabled
  );
};

export const getMaintenanceModeState = (
  publisherMetaData?: BootResponse | null
): MaintenanceModeState => {
  const isActive = resolveMaintenanceModeEnabled(publisherMetaData);

  if (!publisherMetaData?.storeTheme) {
    return { isActive, sanitizedHtml: '' };
  }

  const general = publisherMetaData.storeTheme.general;
  const resolved = getStoreSettings(publisherMetaData.storeTheme);
  const maintenanceConfig = resolved.maintenanceModeRichText;
  const rawText = maintenanceConfig?.text;

  let sanitizedHtml = '';
  if (rawText?.trim()) {
    sanitizedHtml = isBase64(rawText)
      ? decodeAndSanitizeBase64Html(rawText)
      : sanitizeRichText(rawText);
  }

  return {
    isActive,
    sanitizedHtml,
    fontColor: maintenanceConfig?.fontColor,
    fontFamily: general?.font,
    logo: general?.logo,
    backgroundImageMobile: general?.backgroundImageMobile,
    backgroundImageDesktop: general?.backgroundImageDesktop,
  };
};
